export default "__VITE_ASSET__BxnRLH79__"